module.exports = __webpack_public_path__ + "static/media/stripe.3de2c72d.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/stripe.png
 ** module id = 1625
 ** module chunks = 0
 **/